import React, { useState, useEffect, useCallback } from "react";
import axios from "../utils/axiosInstance";

const fmt = (d) => d ? new Date(d).toLocaleDateString("rw-RW", { day:"2-digit", month:"short", year:"numeric" }) : "—";

export default function AbashyitsiMudugudu() {
  const [visitors, setVisitors] = useState([]);
  const [loading, setLoading]   = useState(true);
  const [sending, setSending]   = useState(null);
  const [confirm, setConfirm]   = useState(null);
  const [search, setSearch]     = useState("");
  const [toast, setToast]       = useState(null);

  const notify = (msg, type = "ok") => { setToast({ msg, type }); setTimeout(() => setToast(null), 4000); };

  const fetchVisitors = useCallback(async () => {
    setLoading(true);
    try {
      const res = await axios.get("/api/village/visitors");
      setVisitors(res.data || []);
    } catch { notify("Habaye ikosa mu gusoma amakuru.", "err"); }
    finally { setLoading(false); }
  }, []);

  useEffect(() => { fetchVisitors(); }, [fetchVisitors]);

  const handleSend = async (v) => {
    setSending(v.id); setConfirm(null);
    try {
      await axios.post("/api/visitors/send-to-cell", { visitor_id: v.id });
      notify("✅ Umushyitsi yoherejwe kuri Kagari neza!");
      fetchVisitors();
    } catch (err) {
      notify(err?.response?.data?.error || "Kohereza byanze.", "err");
    } finally { setSending(null); }
  };

  const filtered = visitors.filter(v =>
    !search ||
    v.visitor_name?.toLowerCase().includes(search.toLowerCase()) ||
    v.visited_person_name?.toLowerCase().includes(search.toLowerCase()) ||
    v.visitor_phone?.includes(search) ||
    v.isibo_name?.toLowerCase().includes(search.toLowerCase())
  );

  const cols = ["#","Amazina","Indangamuntu","Telefone","Yinjiye","Isibo Yabohereje","Status","Kohereza"];

  return (
    <div style={{ fontFamily:"Nunito Sans, sans-serif", color:"#1e293b" }}>
      {/* Header */}
      <div style={{ marginBottom:20 }}>
        <h2 style={{ margin:0, fontSize:"1.25rem", fontWeight:800, color:"#1e293b", display:"flex", alignItems:"center", gap:8 }}>
          <i className="bi bi-person-lines-fill" style={{ color:"#1d4ed8" }} /> Abashyitsi Dufite
        </h2>
        <p style={{ margin:"4px 0 0", fontSize:"0.78rem", color:"#64748b" }}>Abashyitsi boherejwe n'Amasibo — ohereza kuri Kagari</p>
      </div>

      {/* Stats */}
      <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(130px,1fr))", gap:12, marginBottom:20 }}>
        {[
          { label:"Bose", value:visitors.length, color:"#1d4ed8" },
          { label:"Itegereye Kagari", value:visitors.filter(v => !v.sent_to_cell_at).length, color:"#f59e0b" },
          { label:"Yoherejwe Kagari", value:visitors.filter(v => !!v.sent_to_cell_at).length, color:"#10b981" },
        ].map(s => (
          <div key={s.label} style={{ background:"#fff", border:"1px solid #e2e8f0", borderRadius:12, padding:"14px 16px", display:"flex", flexDirection:"column", gap:4, boxShadow:"0 1px 4px rgba(0,0,0,0.06)" }}>
            <div style={{ fontSize:"1.5rem", fontWeight:800, color:s.color }}>{s.value}</div>
            <div style={{ fontSize:"0.7rem", color:"#64748b", fontWeight:600 }}>{s.label}</div>
          </div>
        ))}
      </div>

      {/* Toolbar */}
      <div style={{ display:"flex", gap:10, marginBottom:16, flexWrap:"wrap" }}>
        <div style={{ display:"flex", alignItems:"center", gap:8, flex:"1 1 220px", background:"#f8fafc", border:"1px solid #e2e8f0", borderRadius:10, padding:"0 12px", minWidth:0 }}>
          <i className="bi bi-search" style={{ color:"#94a3b8" }} />
          <input value={search} onChange={e => setSearch(e.target.value)} placeholder="Shakisha..."
            style={{ border:"none", background:"transparent", outline:"none", padding:"0.6rem 0.25rem", fontSize:"0.88rem", color:"#1e293b", width:"100%" }} />
          {search && <button onClick={() => setSearch("")} style={{ background:"none", border:"none", cursor:"pointer", color:"#94a3b8", padding:0 }}><i className="bi bi-x-circle-fill" /></button>}
        </div>
        <button onClick={fetchVisitors} disabled={loading} style={{ display:"flex", alignItems:"center", gap:6, padding:"0.55rem 1rem", background:"#f8fafc", border:"1px solid #e2e8f0", borderRadius:10, cursor:"pointer", fontSize:"0.85rem", color:"#475569", fontWeight:600 }}>
          <i className="bi bi-arrow-clockwise" /> Vugurura
        </button>
      </div>
      <div style={{ marginBottom:12, fontSize:"0.82rem", color:"#64748b", fontWeight:600 }}>
        {filtered.length} / {visitors.length} abashyitsi
      </div>

      {loading ? (
        <div style={{ textAlign:"center", padding:"4rem 0" }}>
          <div className="spinner-border text-primary" style={{ width:"3rem", height:"3rem" }} />
          <p style={{ marginTop:"1rem", color:"#64748b" }}>Gutegereza...</p>
        </div>
      ) : filtered.length === 0 ? (
        <div style={{ textAlign:"center", padding:"5rem 2rem", background:"#f8fafc", borderRadius:14, border:"1px solid #e2e8f0" }}>
          <i className="bi bi-person-x" style={{ fontSize:"2.5rem", color:"#94a3b8", display:"block", marginBottom:12 }} />
          <h5 style={{ color:"#1e293b", fontWeight:700 }}>{search ? "Nta mushyitsi wabonetse" : "Nta mushyitsi woherejwe kuri ubu"}</h5>
          <p style={{ color:"#64748b", maxWidth:340, margin:"0.5rem auto 0" }}>Amasibo ntagohereje umushyitsi nawe ubu.</p>
        </div>
      ) : (
        <div style={{ overflowX:"auto", borderRadius:12, border:"1px solid #e2e8f0", boxShadow:"0 1px 4px rgba(0,0,0,0.06)" }}>
          <table style={{ width:"100%", borderCollapse:"collapse", fontSize:"0.83rem" }}>
            <thead>
              <tr style={{ background:"#f1f5f9" }}>
                {cols.map(h => (
                  <th key={h} style={{ padding:"10px 14px", textAlign:"left", fontSize:"0.7rem", fontWeight:700, color:"#475569", textTransform:"uppercase", letterSpacing:"0.05em", whiteSpace:"nowrap", borderBottom:"1px solid #e2e8f0" }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filtered.map((v, i) => {
                const sentToCell = !!v.sent_to_cell_at;
                return (
                  <tr key={v.id} style={{ borderBottom:"1px solid #f1f5f9", background: i%2===0 ? "#fff" : "#f8fafc" }}>
                    <td style={{ padding:"10px 14px", color:"#94a3b8" }}>{i+1}</td>
                    <td style={{ padding:"10px 14px", fontWeight:600, color:"#1e293b" }}>{v.visitor_name}</td>
                    <td style={{ padding:"10px 14px", color:"#64748b" }}>{v.visited_person_id || "—"}</td>
                    <td style={{ padding:"10px 14px", color:"#64748b" }}>{v.visitor_phone || "—"}</td>
                    <td style={{ padding:"10px 14px", color:"#64748b", whiteSpace:"nowrap" }}>{fmt(v.check_in)}</td>
                    <td style={{ padding:"10px 14px", color:"#1d4ed8", fontWeight:600 }}>{v.isibo_name || "—"}</td>
                    <td style={{ padding:"10px 14px" }}>
                      {sentToCell ? (
                        <span style={{ padding:"3px 10px", borderRadius:20, fontSize:"0.72rem", fontWeight:700, background:"#dcfce7", color:"#15803d", border:"1px solid #bbf7d0" }}>🏛️ Kuri Kagari</span>
                      ) : (
                        <span style={{ padding:"3px 10px", borderRadius:20, fontSize:"0.72rem", fontWeight:700, background:"#fef3c7", color:"#b45309", border:"1px solid #fde68a" }}>⏳ Itegereye</span>
                      )}
                    </td>
                    <td style={{ padding:"10px 14px" }}>
                      {!sentToCell ? (
                        <button onClick={() => setConfirm(v)} disabled={sending === v.id}
                          style={{ display:"inline-flex", alignItems:"center", gap:5, padding:"6px 12px", borderRadius:8, border:"none", background:"linear-gradient(135deg,#7c3aed,#6d28d9)", color:"#fff", fontWeight:700, fontSize:"0.78rem", cursor:"pointer", whiteSpace:"nowrap" }}>
                          <i className="bi bi-send-fill" /> Ohereza ku Kagari
                        </button>
                      ) : (
                        <span style={{ fontSize:"0.75rem", color:"#94a3b8", fontStyle:"italic" }}>Yoherejwe</span>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}

      {/* Confirm Modal */}
      {confirm && (
        <div onClick={() => setConfirm(null)} style={{ position:"fixed", inset:0, background:"rgba(15,23,42,0.75)", backdropFilter:"blur(8px)", zIndex:2000, display:"flex", alignItems:"center", justifyContent:"center", padding:16 }}>
          <div onClick={e => e.stopPropagation()} style={{ background:"#fff", borderRadius:20, padding:"2rem", maxWidth:420, width:"100%", textAlign:"center", boxShadow:"0 25px 60px rgba(0,0,0,0.25)" }}>
            <div style={{ width:60, height:60, borderRadius:"50%", background:"#ede9fe", color:"#7c3aed", display:"flex", alignItems:"center", justifyContent:"center", fontSize:"1.6rem", margin:"0 auto 16px" }}>
              <i className="bi bi-send-fill" />
            </div>
            <h3 style={{ color:"#1e293b", marginBottom:8, fontSize:"1.05rem", fontWeight:800 }}>Ohereza ku Kagari</h3>
            <p style={{ color:"#64748b", fontSize:"0.88rem", marginBottom:8 }}>Ushaka kohereza uyu mushyitsi kuri Kagari:</p>
            <p style={{ fontWeight:700, color:"#7c3aed", fontSize:"0.95rem", marginBottom:20, padding:"8px 12px", background:"#ede9fe", borderRadius:8 }}>«{confirm.visitor_name}»</p>
            <div style={{ display:"flex", gap:10 }}>
              <button onClick={() => setConfirm(null)} style={{ flex:1, padding:"10px 16px", borderRadius:10, border:"1px solid #e2e8f0", background:"#f8fafc", color:"#475569", fontWeight:600, cursor:"pointer" }}>Reka</button>
              <button onClick={() => handleSend(confirm)} disabled={sending === confirm?.id}
                style={{ flex:1, padding:"10px 16px", borderRadius:10, border:"none", background:"linear-gradient(135deg,#7c3aed,#6d28d9)", color:"#fff", fontWeight:800, cursor:"pointer" }}>
                {sending === confirm?.id ? <><span className="spinner-border spinner-border-sm" style={{ marginRight:6 }} />Kohereza...</> : <><i className="bi bi-send-fill" style={{ marginRight:6 }} />Yego, Ohereza</>}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Toast */}
      {toast && (
        <div style={{ position:"fixed", top:20, right:20, zIndex:9999, padding:"12px 20px", borderRadius:12, fontWeight:600, fontSize:14, background: toast.type==="ok" ? "#ecfdf5" : "#fef2f2", color: toast.type==="ok" ? "#065f46" : "#991b1b", border:`1px solid ${toast.type==="ok" ? "#a7f3d0" : "#fecaca"}`, boxShadow:"0 4px 20px rgba(0,0,0,0.1)" }}>
          {toast.msg}
        </div>
      )}
    </div>
  );
}
